module.exports = __webpack_public_path__ + "img/search.4b60718c.svg";